import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import BarChartWidget from 'widgets/charts/BarChartWidget'
import GuestCountChartTooltip from 'widgets/charts/GuestCountChartTooltip'
import LineChartWidget from 'widgets/charts/LineChartWidget'

export default function GuestCountBarChartLoader () {
  const entries = useValue('graph_data', [])

  const bars = [
    {
      dataKey: 'this_period',
      fill: '#616DE1'
    },
    {
      dataKey: 'last_period',
      fill: '#CED2F6'
    }
  ]

  return (
    <BarChartWidget
      data={entries}
      bars={bars}
      tooltipContent={<GuestCountChartTooltip />}
      xDataKey='name'
      yTick={{
        type: 'compact_number'
      }}
    />
  )
}
